import * as React from 'react';

function SvgPause(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.535 6.621h4.03a.7.7 0 01.7.7V23.38a.7.7 0 01-.7.7h-4.03a.7.7 0 01-.7-.7V7.32a.7.7 0 01.7-.7zm.7 1.4V22.68h2.63V8.02h-2.63zm7.046-1.4h4.03a.7.7 0 01.7.7V23.38a.7.7 0 01-.7.7h-4.03a.7.7 0 01-.7-.7V7.32a.7.7 0 01.7-.7zm.7 16.058h2.63V8.02h-2.63V22.68z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgPause;
